// 🚗 Vehicles Dashboard complet : recherche, Lightbox, toast, ajout/modification
import React, { useEffect, useState, useRef, useCallback } from "react";
import { db, storage } from "../firebase";
import {
  getDoc,
  updateDoc,
  collection,
  getDocs,
  doc,
  addDoc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut
} from "firebase/auth";

import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from "firebase/storage";
import { Toast } from "bootstrap";
import Sidebar from "../components/Sidebar";
import { FaEdit, FaTrash, FaPlus, FaSearch } from "react-icons/fa";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import VehicleStatusCard from "../components/VehicleStatusCard"; // adapte le chemin selon l'organisation
import CopyLinkButton from "../components/CopyLinkButton";

import html2canvas from "html2canvas";

export default function ItemsManager() {
  const [vehicles, setVehicles] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [search, setSearch] = useState("");
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const toastRef = useRef(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [vehicleToDelete, setVehicleToDelete] = useState(null);
  const cardRefs = useRef({});
  const [statusVehicle, setStatusVehicle] = useState(null);

  const [formData, setFormData] = useState({
    nom: "",
    categorie: "",
    marque: "",
    modele: "",
    prix: "",
    stock: "",
    etat: "neuf",
    description: "",
    imageUrls: [],
    images: [],
    videos: [],
    videoUrls: [],
    ficheTechnique: {
      poids: "",
      puissance: "",
      dimensions: "",
      capacite: "",
      utilisation: "",
    },
    location: "",
    slug: "",
    disponible: true,
  });

  const [marques, setMarques] = useState([]);
  const [modeles, setModeles] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!formData.marque) return;

    const selectedMarque = marques.find((m) => m.nom === formData.marque);
    if (selectedMarque) {
      setModeles(selectedMarque.modeles || []);
    }
  }, [formData.marque, marques]);
  useEffect(() => {
    const updateModelesAndFiche = async () => {
      if (!formData.marque) return;

      const marqueObj = marques.find((m) => m.nom === formData.marque);
      if (marqueObj) {
        setModeles(marqueObj.modeles || []);

        if (formData.modele && !editId) {
          const modeleObj = marqueObj.modeles.find((m) => m.nom === formData.modele);
          if (modeleObj) {
            const docRef = doc(db, `marquesE/${marqueObj.id}/modeles/${modeleObj.id}`);
            const docSnap = await getDoc(docRef);
            const ficheTechnique = docSnap.exists() ? docSnap.data().ficheTechnique || {} : {};

            setFormData((prev) => ({
              ...prev,
              ficheTechnique,
            }));
          }
        }
      }
    };

    updateModelesAndFiche();
  }, [formData.marque, formData.modele, marques, editId]);


  const displayImages = [
    ...formData.imageUrls.map((url, index) => ({ id: `url-${index}`, type: "url", src: url })),
    ...formData.images.map((obj) => ({ id: obj.id, type: "file", src: URL.createObjectURL(obj.file) })),
  ];

  const fetchVehicles = useCallback(async () => {
    const snapshot = await getDocs(collection(db, "items"));
    const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    const sorted = data.sort((a, b) => {
      if (a.statut === "disponible") return -1;
      if (b.statut === "disponible") return 1;
      return 0;
    });
    setVehicles(sorted);
    setFilteredVehicles(sorted);
  }, []);

  const fetchMarques = useCallback(async () => {
    const snapshot = await getDocs(collection(db, "marquesE"));
    const allMarques = await Promise.all(
      snapshot.docs.map(async (docSnap) => {
        const marqueData = { id: docSnap.id, ...docSnap.data() };
        const modelesSnap = await getDocs(collection(db, `marquesE/${docSnap.id}/modeles`));
        const modeles = modelesSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        return { ...marqueData, modeles };
      })
    );
    setMarques(allMarques);
  }, []);

  useEffect(() => {
    fetchVehicles();
    fetchMarques();
  }, [fetchVehicles, fetchMarques]);


  const handleChangeMarque = async (e) => {
    const selectedMarque = e.target.value;
    const marqueObj = marques.find((m) => m.nom === selectedMarque);
    setFormData((prev) => ({
      ...prev,
      marque: selectedMarque,
      modele: "",
      ficheTechnique: {}
    }));
    setModeles(marqueObj?.modeles || []);
  };

  const handleChangeModele = async (e) => {
    const selectedModele = e.target.value;
    const marqueObj = marques.find((m) => m.nom === formData.marque);
    const modeleObj = marqueObj?.modeles.find((m) => m.nom === selectedModele);

    if (modeleObj) {
      const docRef = doc(db, `marquesE/${marqueObj.id}/modeles/${modeleObj.id}`);
      const docSnap = await getDoc(docRef);
      const ficheTechnique = docSnap.exists() ? docSnap.data().ficheTechnique || {} : {};

      setFormData((prev) => ({
        ...prev,
        modele: selectedModele,
        ficheTechnique
      }));
    } else {
      setFormData((prev) => ({ ...prev, modele: selectedModele, ficheTechnique: {} }));
    }
  };

  useEffect(() => {
    const term = search.toLowerCase();
    const results = vehicles.filter((v) =>
      v.marque.toLowerCase().includes(term) ||
      v.modele.toLowerCase().includes(term) ||
      v.annee.toString().includes(term)
    );
    setFilteredVehicles(results);
  }, [search, vehicles]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let uploadedImageUrls = formData.imageUrls || [];
      const imagesArray = formData.images || [];
      if (imagesArray.length > 0) {
        uploadedImageUrls = await Promise.all(
          imagesArray.map(async (img) => {
            const imageRef = ref(storage, `items/images/${Date.now()}_${img.file.name}`);
            const snap = await uploadBytes(imageRef, img.file);
            return await getDownloadURL(snap.ref);
          })
        );
      }

      let uploadedVideoUrls = formData.videoUrls || [];
      const videosArray = formData.videos || [];
      if (videosArray.length > 0) {
        uploadedVideoUrls = await Promise.all(
          videosArray.map(async (vid) => {
            const videoRef = ref(storage, `items/videos/${Date.now()}_${vid.file.name}`);
            const snap = await uploadBytes(videoRef, vid.file);
            return await getDownloadURL(snap.ref);
          })
        );
      }

      const data = {
        ...formData,
        imageUrls: uploadedImageUrls,
        videoUrls: uploadedVideoUrls,
        slug: `${formData.nom}-${Date.now()}`.toLowerCase().replace(/\s+/g, '-'),
      };

      // Supprimer les objets File du payload Firestore
      delete data.images;
      delete data.videos;

      if (editId) {
        await updateDoc(doc(db, "items", editId), data);
        setToastMessage("Véhicule mis à jour avec succès !");
      } else {
        const existing = await getDocs(query(collection(db, "items"), where("slug", "==", data.slug)));
        if (!existing.empty) {
          setToastMessage("Ce véhicule existe déjà !");
          setToastType("warning");
          setLoading(false);
          showToast();
          return;
        }

        await addDoc(collection(db, "items"), data);
        setToastMessage("Véhicule ajouté avec succès !");
      }

      setToastType("success");
      setShowModal(false);
      setEditId(null);
      setFormData({
        nom: "",
        categorie: "",
        marque: "",
        modele: "",
        prix: "",
        stock: "",
        etat: "neuf",
        description: "",
        images: [],
        videos: [],
        imageUrls: [],
        videoUrls: [],
        ficheTechnique: {
          poids: "",
          puissance: "",
          dimensions: "",
          capacite: "",
          utilisation: "",
        },
        location: "",
        slug: "",
        disponible: true,
      });
      const snapshot = await getDocs(collection(db, "items"));
      const dataUpdated = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setVehicles(dataUpdated);
      setFilteredVehicles(dataUpdated);
    } catch (error) {
      console.error("Erreur :", error);
      setToastMessage(error.message || "Une erreur est survenue !");
      setToastType("danger");
    } finally {
      setLoading(false);
      showToast();
    }
  };

  // const handleDelete = async (id) => {
  //     if (!window.confirm("Supprimer ce véhicule ?")) return;
  //     await deleteDoc(doc(db, "vehicules_auto", id));
  //     const updated = vehicles.filter((v) => v.id !== id);
  //     setVehicles(updated);
  //     setFilteredVehicles(updated);
  //     setToastMessage("Véhicule supprimé.");
  //     setToastType("success");
  //     showToast();
  // };
  const confirmDelete = async () => {
    if (!vehicleToDelete) return;
    await deleteDoc(doc(db, "items", vehicleToDelete.id));
    const updated = vehicles.filter((v) => v.id !== vehicleToDelete.id);
    if (vehicleToDelete.imageUrls?.length) {
      for (const url of vehicleToDelete.imageUrls) {
        const fileRef = ref(storage, url);
        await deleteObject(fileRef).catch((err) => console.warn("Erreur suppression image:", err));
      }
    }

    if (vehicleToDelete.videoUrl) {
      const videoRef = ref(storage, vehicleToDelete.videoUrl);
      await deleteObject(videoRef).catch((err) => console.warn("Erreur suppression vidéo:", err));
    }
    setVehicles(updated);
    setFilteredVehicles(updated);
    setToastMessage("Véhicule supprimé.");
    setToastType("success");
    showToast();
    setVehicleToDelete(null);
  };

  const handleWhatsAppShare = (vehicle) => {
    const url = `${window.location.origin}/vehicules/${vehicle.id}`;
    const message = `🚗 ${vehicle.marque} ${vehicle.modele} - ${parseInt(vehicle.prix).toLocaleString('fr-FR')} FCFA\n📅 ${vehicle.annee} • ${vehicle.ficheTechnique?.carburant} • ${vehicle.ficheTechnique?.transmission}\n👉 Voir plus : ${url}`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleGenerateStatus = async (element, marque, modele) => {
    if (!element) return;

    try {
      const canvas = await html2canvas(element, {
        useCORS: true,
        scale: 2,
        backgroundColor: "#ffffff"
      });
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `status-${marque}-${modele}.png`;
      link.click();
    } catch (error) {
      console.error("Erreur de génération de statut visuel :", error);
    }
  };
  const showToast = () => {
    if (toastRef.current) {
      const toast = new Toast(toastRef.current, { delay: 3000 });
      toast.show();
    }
  };


  return (
    <>
      <div className="d-flex flex-column flex-md-row">
        {/* <div className="d-flex"> */}
        <Sidebar />
        <main className="flex-grow-1 p-3" id="mainContent" style={{ marginLeft: "250px" }}>
          {/* <main className="flex-grow-1 p-4" style={{ marginLeft: "250px" }}> */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="fw-bold d-flex align-items-center gap-2">
              <FaSearch /> Véhicules
            </h2>
            <button className="btn btn-primary" onClick={() => setShowModal(true)}>
              <FaPlus className="me-1" /> Ajouter
            </button>
          </div>
          <div className="input-group mb-4">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher par marque, modèle ou année..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button className="btn btn-outline-secondary" type="button">
              <FaSearch />
            </button>
          </div>

          <div className="row g-4">
            {filteredVehicles.map((v, idx) => {
              const vehicleUrl = `${window.location.origin}/vehicules/${v.id}`;
              const message = `🚗 Découvrez ce outil agricole : ${v.marque} ${v.modele} - ${v.annee}\n\n🔗 ${vehicleUrl}`;

              // const whatsappLink = `https://wa.me/?text=${encodeURIComponent(message)}`;
              const encodedMessage = encodeURIComponent(message);
              const whatsappLink = `https://wa.me/22892076072?text=${encodedMessage}`;

              return (
                <div className="col-md-6 col-lg-4" key={v.id} ref={(el) => cardRefs.current[v.id] = el}>
                  <div className="card h-100 shadow-sm">
                    {v.imageUrls?.length > 0 && (

                      <img
                        loading="lazy"
                        src={v.imageUrls[0]}
                        className="card-img-top"
                        alt={`${v.marque} ${v.modele}`}
                        style={{ height: "200px", objectFit: "cover", cursor: "zoom-in" }}
                        onClick={() => {
                          setLightboxImages(v.imageUrls);
                          setLightboxIndex(0);
                          setLightboxOpen(true);
                        }}
                      />

                    )}
                    <div className="card-body">
                      <h5 className="card-title" style={{ color: "#28a745", fontWeight: "bold" }}>{v.marque} {v.modele}</h5>
                      <p className="card-text">
                        {v.annee} • {v.ficheTechnique?.carburant} • {v.ficheTechnique?.transmission}<br />
                        {v.disponible ? (
                          <span className="badge bg-success ms-2">Disponible</span>
                        ) : (
                          <span className="badge bg-danger ms-2">Indisponible</span>
                        )}
                      </p>

                      <div className="d-flex flex-wrap gap-2 justify-content-center mt-3">

                        {/* 🔗 Copier lien */}
                        <CopyLinkButton vehicleId={v.slug} />

                        {/* 🖼 Générer visuel */}
                        <button
                          className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
                          onClick={() => setStatusVehicle(v)}
                        >
                          <i className="bi bi-image"></i> Visuel
                        </button>

                        {/* 📤 Partage WhatsApp */}
                        <a
                          href={whatsappLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-success btn-sm d-flex align-items-center gap-1"
                        >
                          <i className="bi bi-whatsapp"></i> WhatsApp
                        </a>

                        {/* ✏️ Modifier */}
                        <button
                          className="btn btn-outline-secondary btn-sm d-flex align-items-center"
                          title="Modifier"
                          onClick={() => {
                            const fiche = v.ficheTechnique || {};
                            setEditId(v.id);
                            setFormData({
                              ...v,
                              ficheTechnique: { ...fiche },
                              images: [],
                              video: null,
                            });
                            setShowModal(true);
                          }}

                        >
                          <i className="bi bi-pencil-fill"></i>
                        </button>

                        {/* 🗑 Supprimer */}
                        <button
                          className="btn btn-sm btn-outline-danger"
                          title="Supprimer"
                          onClick={() => setVehicleToDelete(v)}
                        >
                          <i className="bi bi-trash-fill"></i>
                        </button>
                        {v.statut !== "disponible" && (
                          <span className={`badge bg-${v.statut === "vendu" ? "danger" : "warning"} position-absolute top-0 start-0 m-2`}>
                            <span className={`badge bg-${(v.statut || 'inconnu').toUpperCase()}`}>
                              {v.statut || 'inconnu'}
                            </span>

                          </span>
                        )}

                      </div>

                    </div>
                  </div>
                </div>
              );
            })}

          </div>

          {lightboxOpen && (
            <Lightbox
              open={lightboxOpen}
              close={() => setLightboxOpen(false)}
              slides={lightboxImages.map((src) => ({ src }))}
              index={lightboxIndex}
              on={{
                view: ({ index }) => setLightboxIndex(index)
              }}
            />
          )}

          <div
            ref={toastRef}
            className={`toast position-fixed bottom-0 end-0 m-4 text-white bg-${toastType}`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{ zIndex: 1055 }}
          >
            <div className="toast-header">
              <strong className="me-auto">Notification</strong>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
            <div className="toast-body">{toastMessage}</div>
          </div>
        </main >
      </div >
      {/* Modal d'ajout/modification inclus plus haut si showModal est true */}
      {/* ... Insérer ici le bloc du formulaire que tu avais copié précédemment ... */}
      {showModal && (
        <div className="modal show fade d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editId ? "Modifier" : "Ajouter"} un véhicule</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  {/* 👉 Ici tu colles tout le contenu de ton formulaire que tu avais mis dans modal-body */}
                  {/* 🟢 Section 1 - Informations Générales */}
                  {/* 🔵 Section 2 - Fiche Technique */}
                  {/* 🟣 Section 3 - Médias */}
                  <div className="modal-body">

                    {/* 🟢 Section 1 - Informations Générales */}
                    <h6 className="fw-bold text-primary mb-3">Informations Générales</h6>
                    <h6 className="fw-bold text-primary mb-3">Informations Générales</h6>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Nom de l'article"
                          value={formData.nom}
                          onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                          required
                        />
                      </div>

                      <div className="col-md-6 mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Catégorie"
                          value={formData.categorie}
                          onChange={(e) => setFormData({ ...formData, categorie: e.target.value })}
                          required
                        />
                      </div>

                      {/* 🔽 MARQUE = SELECT */}
                      <div className="col-md-6 mb-2">
                        <select
                          className="form-select"
                          value={formData.marque}
                          onChange={handleChangeMarque}
                          required
                        >
                          <option value="">Sélectionnez une marque</option>
                          {(marques || []).map((m) => (
                            <option key={m.id} value={m.nom}>
                              {m.nom}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* 🔽 MODELE = SELECT */}
                      <div className="col-md-6 mb-2">
                        <select
                          className="form-select"
                          value={formData.modele}
                          onChange={handleChangeModele}
                          disabled={!formData.marque}
                          required
                        >
                          <option value="">Sélectionnez un modèle</option>
                          {(modeles || []).map((modele) => (
                            <option key={modele.id} value={modele.nom}>
                              {modele.nom}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6 mb-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Prix (FCFA)"
                          value={formData.prix}
                          onChange={(e) => setFormData({ ...formData, prix: e.target.value })}
                        />
                      </div>

                      <div className="col-md-6 mb-2">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Stock"
                          value={formData.stock}
                          onChange={(e) => setFormData({ ...formData, stock: e.target.value })}
                        />
                      </div>

                      <div className="col-md-6 mb-2">
                        <select
                          className="form-select"
                          value={formData.etat}
                          onChange={(e) => setFormData({ ...formData, etat: e.target.value })}
                        >
                          <option value="neuf">Neuf</option>
                          <option value="occasion">Occasion</option>
                        </select>
                      </div>

                      <div className="col-md-6 mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Lieu (ville, région)"
                          value={formData.location}
                          onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                        />
                      </div>

                      <div className="col-12 mb-2">
                        <textarea
                          className="form-control"
                          placeholder="Description"
                          rows={3}
                          value={formData.description}
                          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        />
                      </div>
                      <div className="col-md-6 mb-2 d-flex align-items-center">
                        <input
                          type="checkbox"
                          className="form-check-input me-2"
                          id="disponible"
                          checked={formData.disponible}
                          onChange={(e) => setFormData({ ...formData, disponible: e.target.checked })}
                        />
                        <label htmlFor="disponible" className="form-check-label">Disponible</label>
                      </div>
                    </div>
                    {/* 🔵 Section 2 - Fiche technique */}
                    <h6 className="fw-bold text-primary mb-3">Fiche Technique</h6>
                    <div className="row">
                      {[
                        ["Poids", "poids"],
                        ["Puissance", "puissance"],
                        ["Dimensions", "dimensions"],
                        ["Capacité", "capacite"],
                        ["Utilisation", "utilisation"]
                      ].map(([label, key]) => (
                        <div className="col-md-6 mb-2" key={key}>
                          <input type="text" className="form-control" placeholder={label}
                            value={formData.ficheTechnique[key] || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                ficheTechnique: {
                                  ...formData.ficheTechnique,
                                  [key]: e.target.value
                                }
                              })
                            } />
                        </div>
                      ))}
                    </div>


                    {/* 🟣 Section 3 - Médias */}
                    <h6 className="fw-bold text-primary mt-4 mb-3">Images & Vidéo</h6>
                    <label className="form-label">Images (la première sera utilisée comme image principale)</label>
                    <p className="text-muted">
                      Images ajoutées : {formData.images.length + formData.imageUrls.length} / 11
                    </p>

                    <input
                      className="form-control mb-2"
                      type="file"
                      accept="image/*"
                      multiple
                      // onChange={(e) =>
                      //     setFormData({
                      //         ...formData,
                      //         images: Array.from(e.target.files),
                      //     })
                      // }
                      // onChange={(e) => {
                      //     const files = Array.from(e.target.files).map((file) => ({
                      //         id: `${file.name}-${file.lastModified}`,
                      //         file,
                      //     }));
                      //     setFormData({
                      //         ...formData,
                      //         images: files,
                      //     });
                      // }}
                      // onChange={(e) => {
                      //     const files = Array.from(e.target.files);
                      //     const MAX_IMAGES = 11;

                      //     if (formData.images.length + files.length > MAX_IMAGES) {
                      //         alert(`Vous ne pouvez ajouter que ${MAX_IMAGES} images au maximum.`);
                      //         return;
                      //     }
                      //     const MAX_SIZE_MB = 2;

                      //     const oversized = files.find((file) => file.size > MAX_SIZE_MB * 1024 * 1024);
                      //     if (oversized) {
                      //         alert(`Chaque image doit faire moins de ${MAX_SIZE_MB} Mo.`);
                      //         return;
                      //     }


                      //     const newFiles = files.map((file) => ({
                      //         id: `${file.name}-${file.lastModified}`,
                      //         file,
                      //     }));

                      //     setFormData({
                      //         ...formData,
                      //         images: [...formData.images, ...newFiles],
                      //     });
                      // }}
                      onChange={(e) => {
                        const files = Array.from(e.target.files);
                        const MAX_IMAGES = 11;

                        // Sécurise l'accès à .length
                        const currentImages = formData.images || [];
                        const currentImageUrls = formData.imageUrls || [];
                        const totalSelected = currentImages.length + currentImageUrls.length;
                        const remaining = MAX_IMAGES - totalSelected;

                        if (remaining <= 0) {
                          alert("Vous avez déjà atteint la limite de 11 images.");
                          return;
                        }

                        const allowedFiles = files.slice(0, remaining);

                        const oversized = allowedFiles.find((file) => file.size > 2 * 1024 * 1024);
                        if (oversized) {
                          alert("Chaque image doit faire moins de 2 Mo.");
                          return;
                        }

                        const newFiles = allowedFiles.map((file) => ({
                          id: `${file.name}-${file.lastModified}`,
                          file,
                        }));

                        setFormData({
                          ...formData,
                          images: [...currentImages, ...newFiles],
                        });

                        if (files.length > remaining) {
                          setToastMessage(`Seules ${remaining} images ont été ajoutées sur ${files.length} sélectionnées.`);
                          setToastType("warning");
                          showToast();
                        }
                      }}


                    />
                    <small className="text-muted">Max. 11 images. Chaque image doit faire moins de 2 Mo.</small>
                    {/* Le champ image et preview existant restent inchangés ici */}
                    <div className="d-flex flex-wrap gap-2">
                      {displayImages.map((img, i) => (
                        <div
                          key={img.id}
                          draggable
                          onDragStart={() => setDragIndex(i)}
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={() => {
                            if (dragIndex === null || dragIndex === i) return;

                            const newDisplay = [...displayImages];
                            const [moved] = newDisplay.splice(dragIndex, 1);
                            newDisplay.splice(i, 0, moved);

                            setFormData({
                              ...formData,
                              imageUrls: newDisplay
                                .filter((img) => img.type === "url")
                                .map((img) => img.src),
                              images: newDisplay
                                .filter((img) => img.type === "file")
                                .map((img) => formData.images.find((f) => f.id === img.id)),
                            });

                            setDragIndex(null);
                          }}
                          title="Glisser pour réorganiser"
                          style={{ cursor: "move", position: "relative" }}
                        >
                          {/* Badge image principale */}
                          {i === 0 && (
                            <span className="badge bg-primary position-absolute top-0 start-0">
                              Principale
                            </span>
                          )}

                          {/* Bouton de suppression */}
                          <button
                            type="button"
                            className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 d-flex align-items-center justify-content-center"
                            style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "50%",
                              padding: 0,
                              zIndex: 2,
                            }}
                            onClick={() => {
                              const newDisplay = displayImages.filter((d) => d.id !== img.id);
                              setFormData({
                                ...formData,
                                imageUrls: newDisplay
                                  .filter((x) => x.type === "url")
                                  .map((x) => x.src),
                                images: newDisplay
                                  .filter((x) => x.type === "file")
                                  .map((x) =>
                                    formData.images.find((f) => f.id === x.id)
                                  ),
                              });
                            }}
                            title="Supprimer"
                          >
                            <FaTrash size={12} />
                          </button>

                          <img
                            src={img.src}
                            alt={`img-${i}`}
                            width="70"
                            height="70"
                            className="rounded border"
                          />
                        </div>
                      ))}

                    </div>

                    <label className="form-label mt-3">Vidéo</label>
                    {/* Le champ vidéo que tu as avec validation taille 20Mo */}
                    <input
                      className="form-control"
                      type="file"
                      accept="video/*"
                      multiple
                      onChange={(e) => {
                        const files = Array.from(e.target.files);
                        const MAX_VIDEOS = 3;
                        const MAX_VIDEO_MB = 20;

                        // Sécurise l'accès à .length
                        const currentVideos = formData.videos || [];
                        if (currentVideos.length + files.length > MAX_VIDEOS) {
                          alert(`Vous pouvez ajouter jusqu'à ${MAX_VIDEOS} vidéos.`);
                          return;
                        }

                        // Vérifie la taille
                        const oversized = files.find((file) => file.size > MAX_VIDEO_MB * 1024 * 1024);
                        if (oversized) {
                          alert(`Chaque vidéo doit faire moins de ${MAX_VIDEO_MB} Mo.`);
                          return;
                        }

                        const newFiles = files.map((file) => ({
                          id: `${file.name}-${file.lastModified}`,
                          file,
                        }));

                        setFormData({
                          ...formData,
                          videos: [...currentVideos, ...newFiles],
                        });
                      }}
                    />
                    <small className="text-muted">Max. 3 vidéos. Chaque vidéo doit faire moins de 20 Mo. Formats supportés : mp4, mov, avi.</small>

                    {(formData.videos || []).map((vid, idx) => (
                      <div key={vid.id} style={{ position: "relative", display: "inline-block", marginRight: 8 }}>
                        <video
                          width="100%"
                          height="auto"
                          className="mt-2 rounded"
                          controls
                          src={URL.createObjectURL(vid.file)}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                          style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            padding: 0,
                            zIndex: 2,
                          }}
                          title="Supprimer cette vidéo"
                          onClick={() => {
                            setFormData({
                              ...formData,
                              videos: (formData.videos || []).filter((v, i) => i !== idx),
                            });
                          }}
                        >
                          <FaTrash size={12} />
                        </button>
                      </div>
                    ))}
                    {(formData.videoUrls || []).map((url, idx) => (
                      <div key={idx} style={{ position: "relative", display: "inline-block", marginRight: 8 }}>
                        <video
                          width="100%"
                          height="auto"
                          className="mt-2 rounded"
                          controls
                          src={url}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                          style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            padding: 0,
                            zIndex: 2,
                          }}
                          title="Supprimer cette vidéo"
                          onClick={async () => {
                            // Supprime le fichier dans Firebase Storage
                            try {
                              const videoRef = ref(storage, url);
                              await deleteObject(videoRef);
                            } catch (err) {
                              setToastMessage("Erreur lors de la suppression de la vidéo !");
                              setToastType("danger");
                              showToast();
                            }
                            // Supprime l'URL du state
                            setFormData({
                              ...formData,
                              videoUrls: (formData.videoUrls || []).filter((v, i) => i !== idx),
                            });
                          }}
                        >
                          <FaTrash size={12} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Traitement...
                      </>
                    ) : (
                      "Enregistrer"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {
        statusVehicle && (
          <div className="modal show fade d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Aperçu du statut</h5>
                  <button className="btn-close" onClick={() => setStatusVehicle(null)}></button>
                </div>
                <div className="modal-body d-flex justify-content-center">
                  <VehicleStatusCard vehicle={statusVehicle} />
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        vehicleToDelete && (
          <div className="modal show fade d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header bg-danger text-white">
                  <h5 className="modal-title">Confirmation</h5>
                  <button type="button" className="btn-close" onClick={() => setVehicleToDelete(null)}></button>
                </div>
                <div className="modal-body">
                  <p>
                    Voulez-vous vraiment supprimer <strong>{vehicleToDelete.marque} {vehicleToDelete.modele}</strong> ?
                  </p>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setVehicleToDelete(null)}>
                    Annuler
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Oui, supprimer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {
        loading && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75"
            style={{ zIndex: 2000 }}
          >
            <div className="text-center">
              <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                <span className="visually-hidden">Chargement...</span>
              </div>
              <div className="mt-3 fw-bold">Traitement en cours...</div>
            </div>
          </div>
        )
      }
    </>
  );
}